import styled, { keyframes } from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
const fadeInFadeOut = keyframes `
  0% {
    opacity: 1
  }

  50% {
    opacity: 0.4
  }

  100% {
    opacity: 1
  }
`;
const StyledCommonSkeletonShape = styled.div.withConfig({ displayName: "auir-611444a-StyledCommonSkeletonShape", componentId: "auir-611444a-f4ly5g" }) `
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  aspect-ratio: ${(props) => props.aspectRatio};
  background-color: var(${(props) => props.theme.colors.ui.highlight.tertiary});
  -webkit-animation: ${fadeInFadeOut} 2s ease-in-out 0.5s infinite;
  animation: ${fadeInFadeOut} 2s ease-in-out 0.5s infinite;
  cursor: progress;
  ${injectSpacing('margin')}
`;
export const StyledRectangularSkeletonShape = styled(StyledCommonSkeletonShape).withConfig({ displayName: "auir-611444a-StyledRectangularSkeletonShape", componentId: "auir-611444a-1m8k1rd" }) `
  border-radius: 0%;
`;
export const StyledCircularSkeletonShape = styled(StyledCommonSkeletonShape).withConfig({ displayName: "auir-611444a-StyledCircularSkeletonShape", componentId: "auir-611444a-1y3ms7w" }) `
  border-radius: 100%;
`;
export const StyledOvalSkeletonShape = styled(StyledCommonSkeletonShape).withConfig({ displayName: "auir-611444a-StyledOvalSkeletonShape", componentId: "auir-611444a-14hjtf2" }) `
  border-radius: 40px;
`;
//# sourceMappingURL=SkeletonShape.styles.mjs.mjs.map